export const ATTENDANCE_GET_MULTIPLE =  "ATTENDANCE_GET_MULTIPLE"
export const ATTENDANCE_GET_DROPDOWNS =  "ATTENDANCE_GET_DROPDOWNS"
export const ATTENDANCE_GET_ONE =  "ATTENDANCE_GET_ONE"
export const ATTENDANCE_REGISTER_SUCCESS =  "ATTENDANCE_REGISTER_SUCCESS"
export const ATTENDANCE_REGISTER_FAIL =  "ATTENDANCE_REGISTER_FAIL"
export const ATTENDANCE_LOADING =  "ATTENDANCE_LOADING"
export const ATTENDANCE_LOADING_ERROR =  "ATTENDANCE_LOADING_ERROR"
export const ATTENDANCE_ACTIVATE_FAIL =  "ATTENDANCE_ACTIVATE_FAIL"
export const ATTENDANCE_ACTIVATE_SUCCESS =  "ATTENDANCE_ACTIVATE_SUCCESS"
export const ATTENDANCE_UPDATE_SUCCESS =  "ATTENDANCE_UPDATE_SUCCESS"
export const ATTENDANCE_UPDATE_FAIL =  "ATTENDANCE_UPDATE_FAIL"
export const ATTENDANCE_DELETE_SUCCESS =  "ATTENDANCE_DELETE_SUCCESS"
export const ATTENDANCE_DELETE_FAIL =  "ATTENDANCE_DELETE_FAIL"
export const ATTENDANCE_EDIT =  "ATTENDANCE_EDIT"